import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import {
  Actions,
  Description,
  FooterNote,
  IconWrapper,
  ModalContent,
  RecipientsList,
  Title
} from './styles';

const EnvelopeIcon = () => (
  <svg
    width="56"
    height="48"
    viewBox="0 0 56 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 10.5C6 8.01472 8.01472 6 10.5 6H45.5C47.9853 6 50 8.01472 50 10.5V37.5C50 39.9853 47.9853 42 45.5 42H10.5C8.01472 42 6 39.9853 6 37.5V10.5Z"
      stroke="#59249B"
      strokeWidth="3"
    />
    <path
      d="M8 9L28 24L48 9"
      stroke="#59249B"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 28H36"
      stroke="#59249B"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

interface CreditasSignatureConfirmationModalProps {
  open: boolean;
  onClose: () => void;
}

const CreditasSignatureConfirmationModal: React.FC<CreditasSignatureConfirmationModalProps> = ({
  open,
  onClose
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="tiny"
      style={{
        width: '476px',
        border: '1px solid #b8d4ea',
        borderRadius: '8px'
      }}
    >
      <Modal.Content>
        <ModalContent>
          <IconWrapper>
            <EnvelopeIcon />
          </IconWrapper>
          <Title>Assinatura do Termo de Garantia</Title>
          <Description>
            O link para realizar a assinatura eletrônica do termo será enviado por e-mail
            para:
          </Description>
          <RecipientsList>
            <li>Locador</li>
            <li>Locatário</li>
            <li>Responsável pela imobiliária</li>
          </RecipientsList>
          <FooterNote>
            A garantia só será emitida após a assinatura de <strong>todas</strong> as
            partes.
          </FooterNote>
        </ModalContent>
      </Modal.Content>
      <Modal.Actions>
        <Actions>
          <Button
            color="grey"
            type="button"
            onClick={onClose}
            style={{
              paddingLeft: '36px',
              paddingRight: '36px'
            }}
          >
            Fechar
          </Button>
        </Actions>
      </Modal.Actions>
    </Modal>
  );
};

export default CreditasSignatureConfirmationModal;
